import type { MenuScreen } from '../types.js';
import { createScreenShell, createMenuHeader, el } from '@bn-games/ui-shell';
import { t } from '../../i18n/I18n.js';
import { APP_VERSION } from '../../utils/version.js';
import { backRow } from './backButton.js';

export function createAboutScreen(): MenuScreen {
  let frame: HTMLElement | null = null;

  return {
    mount(root, ctx) {
      const shell = createScreenShell();
      frame = shell.frame;
      const about = el('div', {
        class: 'about',
        attrs: { role: 'region', 'aria-label': t('mainMenu.about'), tabindex: '0' },
      }, [
        el('p', { class: 'about-paragraph', text: t('about.version', { version: APP_VERSION }) }),
        el('p', { class: 'about-paragraph', text: t('about.body') }),
        el('p', { class: 'about-paragraph', text: t('about.tech') }),
      ]);
      shell.body.append(createMenuHeader({ title: t('mainMenu.about') }), about, backRow(ctx));
      root.appendChild(frame);
    },
    unmount() {
      frame?.remove();
      frame = null;
    },
  };
}
